// import apiService from '../../helpers/ApiService'
// import socketClient from '../../helpers/SocketClient'
// import * as Constants from '../../helpers/Constants'

const LOGIN_SUCCESS = 'login-success'
const LOGIN_FAILED = 'login-failed'
const LOGOUT_SUCCESS = "logout-success"
const CHAT_USER_FETCHED = "chat-user-fetched"

const initialState = { id: 0, name: 'User', pic: '', isLogged: false, isOnline: false, jwtToken: null, chatUserFetched: false, chatUserId: null }

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        id: action.payload.user_id,
        name: action.payload.name,
        jwtToken: action.payload.token,
        session_id: action.payload.session_id,
        type: action.payload.type,
        isLogged: true,
        isOnline: true
      })

    case LOGIN_FAILED:
      return Object.assign({}, initialState, {
        error_msg: action.payload.error_msg
      })

    case LOGOUT_SUCCESS:
      return Object.assign({}, state, initialState)

    case CHAT_USER_FETCHED:
      return Object.assign({}, state, { chatUserFetched: true, chatUserId: action.payload })

    default:
      return state
  }
}


export function loginSuccess(payload) {
  return {
    type: LOGIN_SUCCESS,
    payload
  }
}

export function loginFailed(payload) {
  return {
    type: LOGIN_FAILED,
    payload
  }
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS
  }
}

export function chatUserFetched(payload) {
  return {
    type: CHAT_USER_FETCHED,
    payload
  }
}

export function getUserName() {
  return function (dispatch, getState) {
    return getState().userReducer.name
  }
}

export function getJWTToken() {
  return function (dispatch, getState) {
    return getState().userReducer.jwtToken
  }
}

export function getApiToken() {
  return function (dispatch, getState) {
    return getState().userReducer.jwtToken
  }
}


// WEBPACK FOOTER //
// ./src/components/user/user_reducer.js